import React, { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { withRouter } from 'react-router';

import { useConfig } from '../../../contexts/config';
import { useAppSettings } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { tokenExpiryErrorCheck } from '../../../utils';
import PageError from './index';
import { ModalWrapper } from './style';
import { ErrorPageProps } from './types';

const BackToDashboardError = ({ history, error, pageName }: ErrorPageProps): JSX.Element => {
  const { dashboardPath } = usePaths();
  const intl = useIntl();
  const { isTabsShown } = useAppSettings();
  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    xsollaAnalytics.sendOpen(`login_pa_module__${pageName}`, 'error', {
      error: error?.description || ''
    });
  }, []);

  const handleClick = () => {
    history.push(dashboardPath());
  };

  const loginPage = () => {
    history.push('/');
  };

  const expiredToken = useMemo(() => tokenExpiryErrorCheck(error?.code || ''), []);

  return (
    <ModalWrapper showTabs={isTabsShown}>
      <PageError
        title={intl.formatMessage({ id: 'app.error.page.label' })}
        error={error}
        buttonText={intl.formatMessage({
          id: `${expiredToken ? 'button.login' : 'button.to-dashboard'}`
        })}
        onClick={expiredToken ? loginPage : handleClick}
      />
    </ModalWrapper>
  );
};

export default withRouter(BackToDashboardError);
